import type { FC } from 'react';

import styled from 'styled-components';

import type { Button4 as Button } from '~/amplienceTypes/schemas/exported/button-schema';
import { AmplienceCmsLink } from '~/components/shared/core/link/AmplienceCmsLink';
import { categoryTag } from '~/components/unmanaged/styles/BaseStyledElements';

const S = {
  Tag: styled(AmplienceCmsLink)`
    ${categoryTag}
  `,
};

interface Props extends Button {
  onClick?: () => void;
}

export const CategoryTag: FC<Props> = ({ url = '#', hsLink, ariaLabel, target, text, onClick }) => (
  <S.Tag href={url} onClick={onClick} data-hs-link={hsLink} aria-label={ariaLabel} target={target}>
    {text}
  </S.Tag>
);
